import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-event-nav-view',
  templateUrl: './event-nav-view.component.html',
  styleUrls: ['./event-nav-view.component.scss']
})
export class EventNavViewComponent implements OnInit {

  screenStatusSubscription: Subscription;
  leftMenu: boolean = false;
  deviceInfo: any;
  showSubmenu: boolean = false;
  paymentStatusSubscription:Subscription;
  paymentStatus: boolean = false;
  slugInfoSubscr: Subscription;
  slugInfo: any;
  streamInfo: any;

  constructor(public router: Router, private commonSubscribeService: CommanSubscribeService,private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.commonSubscribeService.sendTrackingCode({});
    this.commonSubscribeService.sendMediaPlayerData({});
    this.screenStatusSubscription = this.commonSubscribeService.getScreenStatus().subscribe(response => {
      this.leftMenu = response;
      this.cdRef.detectChanges();
    });
    let device = this.commonSubscribeService.getMobileOperatingSystem();
    if (device == 'ios' || device == 'android') {
      this.deviceInfo = device;
      this.cdRef.detectChanges();
    }
    this.paymentStatusSubscription = this.commonSubscribeService.getPaymentStatus().subscribe(response => {
      this.paymentStatus = response;
    });
    this.slugInfo = this.commonSubscribeService.slugInfo;
    this.slugInfoSubscr = this.commonSubscribeService.getSlugData().subscribe(response => {
      this.slugInfo = response;
      this.streamInfo = this.slugInfo.stream_info ? this.slugInfo.stream_info : this.slugInfo;
      if(this.streamInfo.media_files) {
          let media_files = JSON.parse(this.streamInfo.media_files);
          Object.keys(media_files).forEach(element => {
            this.streamInfo[element] = media_files[element];
         });
        }
        this.cdRef.detectChanges();
    });
  }

  ngOnDestroy() {
    if (this.screenStatusSubscription)
      this.screenStatusSubscription.unsubscribe();
    if(this.paymentStatusSubscription)
      this.paymentStatusSubscription.unsubscribe();
    if (this.slugInfoSubscr)
      this.slugInfoSubscr.unsubscribe();
  }

}
